export default __webpack_public_path__ + "static/media/image_5.8af23dfb.jpg";